import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FightCardProduct, Product } from './FightCardProduct';
const MOCK_PRODUCTS: Product[] = [{
  id: '1',
  name: 'IRON CAGE HOODIE',
  price: 89,
  category: 'HOODIES',
  fighter: 'Conor Style',
  image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?q=80&w=1000&auto=format&fit=crop',
  isNew: true,
  colors: ['#1a1a1a', '#991B1B', '#2d3748']
}, {
  id: '2',
  name: 'WALKOUT OVERSIZED TEE',
  price: 49,
  category: 'SHIRTS',
  image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?q=80&w=1000&auto=format&fit=crop',
  colors: ['#ffffff', '#1a1a1a', '#f5e614']
}, {
  id: '3',
  name: 'BLOOD SWEAT HOODIE',
  price: 95,
  category: 'HOODIES',
  image: 'https://images.unsplash.com/photo-1578768079052-aa76e52ff62e?q=80&w=1000&auto=format&fit=crop',
  isLimited: true,
  colors: ['#991B1B', '#1a1a1a']
}, {
  id: '4',
  name: 'CAGE WARRIOR CAP',
  price: 35,
  category: 'CAPS',
  image: 'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?q=80&w=1000&auto=format&fit=crop',
  colors: ['#1a1a1a', '#3d3d3d', '#f5e614']
}, {
  id: '5',
  name: 'FIGHT NIGHT COMPRESSION',
  price: 65,
  category: 'FIGHTWEAR',
  image: 'https://images.unsplash.com/photo-1517438476312-10d79c077509?q=80&w=1000&auto=format&fit=crop',
  colors: ['#1a1a1a', '#991B1B']
}, {
  id: '6',
  name: 'CHAMPION HOODIE',
  price: 110,
  category: 'HOODIES',
  image: 'https://images.unsplash.com/photo-1556906781-9a412961c28c?q=80&w=1000&auto=format&fit=crop',
  isNew: true,
  colors: ['#2d3748', '#1a1a1a', '#991B1B', '#4a5568']
}, {
  id: '7',
  name: 'OCTAGON SHORTS',
  price: 75,
  category: 'FIGHTWEAR',
  image: 'https://images.unsplash.com/photo-1591195853828-11db59a44f6b?q=80&w=1000&auto=format&fit=crop',
  colors: ['#1a1a1a', '#991B1B', '#f5e614']
}, {
  id: '8',
  name: 'IRON WILL TEE',
  price: 45,
  category: 'SHIRTS',
  image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=1000&auto=format&fit=crop',
  colors: ['#ffffff', '#1a1a1a', '#3d3d3d']
}];
interface FeaturedProductsProps {
  onAddToCart: (product: Product) => void;
}
export function FeaturedProducts({
  onAddToCart
}: FeaturedProductsProps) {
  const [filter, setFilter] = useState('ALL');
  const categories = ['ALL', 'HOODIES', 'SHIRTS', 'CAPS', 'FIGHTWEAR'];
  const filteredProducts = filter === 'ALL' ? MOCK_PRODUCTS : MOCK_PRODUCTS.filter(p => p.category === filter);
  return <section id="shop" className="py-24 bg-fight-black relative" data-id="element-53">
      {/* Subtle background glow */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 50% 0%, rgba(245,230,20,0.02) 0%, transparent 60%)'
    }} data-id="element-54" />

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10" data-id="element-55">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-8" data-id="element-56">
          <div data-id="element-57">
            <h2 className="text-5xl md:text-7xl font-bebas mb-2" style={{
            color: '#e0e0e0'
          }} data-id="element-58">
              FIGHT{' '}
              <span className="underline decoration-4 underline-offset-8" style={{
              color: 'rgba(245,230,20,0.75)',
              textDecorationColor: 'rgba(245,230,20,0.3)',
              textShadow: '0 0 30px rgba(245,230,20,0.2)'
            }} data-id="element-59">
                COLLECTION
              </span>
            </h2>
            <p className="font-barlow text-lg tracking-widest uppercase" style={{
            color: '#555'
          }} data-id="element-60">
              Engineered for the cage. Built for the street.
            </p>
          </div>

          {/* Glass Filter Tabs */}
          <div className="flex flex-wrap gap-2" data-id="element-61">
            {categories.map(cat => <button key={cat} onClick={() => setFilter(cat)} className="px-5 py-2 rounded-full font-barlow font-bold tracking-wider text-sm transition-all duration-300" style={filter === cat ? {
            background: 'rgba(245,230,20,0.1)',
            border: '1px solid rgba(245,230,20,0.3)',
            color: 'rgba(245,230,20,0.85)',
            boxShadow: '0 0 16px rgba(245,230,20,0.08)',
            backdropFilter: 'blur(8px)'
          } : {
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.07)',
            color: '#555',
            backdropFilter: 'blur(8px)'
          }} data-id="element-62">
                {cat}
              </button>)}
          </div>
        </div>

        {/* Grid — always 2 cols on mobile */}
        <motion.div layout className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-63">
          {filteredProducts.map(product => <FightCardProduct key={product.id} product={product} onAddToCart={onAddToCart} data-id="element-64" />)}
        </motion.div>
      </div>
    </section>;
}